

























import {
  computed, defineComponent, reactive, Ref, ref, watch,
} from '@vue/composition-api';
import { useQuery } from '@vue/apollo-composable';

import CommonHubSelector from '@/components/CommonHubSelector.vue';
import HorizontalBarChart from '@/components/Vivat/Chart/HorizontalBarChart.vue';
import ScrollableHorizontalBarChart from '@/components/Vivat/Chart/ScrollableHorizontalBarChart.vue';

import {
  NOW_START_MONTH,
  NOW_END_MONTH,
} from '@/utils';
import {
  deliveryTimeColor,
} from '@/useDelivery';
import areasDeliveryTime from '@/gql/managementReport/04-DeliveryTime/areasDeliveryTime.gql';

const DeliveryTimeByArea = defineComponent({
  components: {
    CommonHubSelector,
    HorizontalBarChart,
    ScrollableHorizontalBarChart,
  },
  props: {
    height: {},
  },
  setup(props) {
    const filter = reactive({
      hub: null,
      monthRange: {
        from: NOW_START_MONTH,
        to: NOW_END_MONTH,
      },
    });

    const { result: areasDeliveryTimeResult } = useQuery(areasDeliveryTime, () => ({
      timeframe: filter.monthRange,
      hubId: filter.hub && (filter.hub as any).id ? (filter.hub as any).id : undefined,
    }));

    const labels: Ref<string[]> = ref([]);
    const day1: Ref<number[]> = ref([]);
    const day2: Ref<number[]> = ref([]);
    const day3: Ref<number[]> = ref([]);
    const day4: Ref<number[]> = ref([]);
    const day7: Ref<number[]> = ref([]);
    watch(() => areasDeliveryTimeResult.value, (newVal, oldVal) => {
      if (newVal && newVal !== oldVal) {
        labels.value = [];
        day1.value = [];
        day2.value = [];
        day3.value = [];
        day4.value = [];
        day7.value = [];
        newVal.areasDeliveryTime.forEach((record: any) => {
          labels.value.push(record.areaCode);
          day1.value.push(record.day0);
          day2.value.push(record.day1);
          day3.value.push(record.day2);
          day4.value.push(record.day4);
          day7.value.push(record.day7);
        });
      }
    });

    const chartData = computed(() => ({
      labels: labels.value.length > 0 ? labels.value : ['ไม่พบข้อมูล'],
      datasets: [
        {
          label: 'วันเดียว',
          data: day1.value,
          backgroundColor: deliveryTimeColor.day1,
          stack: 'STACK',
        },
        {
          label: 'วันถัดไป',
          data: day2.value,
          backgroundColor: deliveryTimeColor.day2,
          stack: 'STACK',
        },
        {
          label: 'ภายใน 3 วัน',
          data: day3.value,
          backgroundColor: deliveryTimeColor.day3,
          stack: 'STACK',
        },
        {
          label: 'ภายใน 4-7 วัน',
          data: day4.value,
          backgroundColor: deliveryTimeColor.day4,
          stack: 'STACK',
        },
        {
          label: 'มากกว่า 7 วัน',
          data: day7.value,
          backgroundColor: deliveryTimeColor.day7,
          stack: 'STACK',
        },
      ],
    }));

    return {
      filter,
      chartData,
    };
  },
});

export default DeliveryTimeByArea;
